import IDPUser from './model.js'
import { deepGet, addToCollection } from '../shared/helper'

export default {
  namespaced: true,
  state: {
    idpUsers: [],
    filteredCollection: [],
    current: new IDPUser()
  },
  getters: {
    getCollection: state => state.idpUsers,
    getFilteredCollection: state => state.filteredCollection,
    getById: state => (id) => state.idpUsers.find(user => user.id === id),
    getCurrent: state => state.current
  },
  actions: {
    getCollection({ commit, getters, state }, payload) {
      return this.dispatch('get', {
        path: 'v1/idp/users',
        ...payload
      }).then((res) => {

        const data = deepGet(res, 'body.data')
        if (data) {

          const models = data.map((user) => {
            commit('addUserToCollection', { userData: user })
            return getters.getById(user.id)
          })

          commit('addUserToFilteredCollection', models)

          return { data: models, meta: res.body.meta }
        }
        return res
      })
    },
    delete({ commit }, id) {
      return this.dispatch('del', {
        path: 'v1/idp/users/' + id
      }).then((res) => {

        commit('removeUserFromCollection', id)

        return res
      })
    },
    setCurrentUser({ commit }, user) {
      commit('updateCurrent', user)
    }
  },
  mutations: {
    addUserToCollection(state, { userData, opts }) {
      addToCollection(this, state.idpUsers, userData, IDPUser, opts)
    },
    addUserToFilteredCollection(state, data) {
      state.filteredCollection = state.filteredCollection.concat(data)
    },
    removeUserFromCollection(state, userId) {
      const index = state.idpUsers.findIndex(el => el.id === userId)

      if (index === -1) {
        console.warn(`Could not find/delete idp user ${userId}`)
        return
      }

      state.idpUsers.splice(index, 1)
    },
    clearCollection(state) {
      state.idpUsers = []
    },
    clearFilteredCollection(state) {
      state.filteredCollection = []
    },
    updateCurrent(state, user) {
      state.current = user
    },
    resetCurrent(state) {
      state.current = new IDPUser()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/idpUser/store.js